import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../../../../images/logo.png";
import { FaSignInAlt, FaPaperPlane, FaBars, FaTimes } from "react-icons/fa";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="Ebench Logo" />
          </Link>
        </div>

        {/* Hamburger for mobile */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </div>

        {/* Center Links */}
        <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/solutions">Solutions</Link>
          </li>

          {/* Products Links */}
          {/* <li
            className="menu-item"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="flex items-center gap-1 cursor-pointer">
             <Link to="/">Products</Link> {isOpen ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            <ul className={`submenu ${isOpen ? "block" : ""}`}>
              <li>
                <a
                  href="https://jobstability.ebench.tech/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Job Stability
                </a>
              </li>
              <li>
                <a
                  href="https://introduction.ebench.tech/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Introduction Video Analyzer
                </a>
              </li>
            </ul>
          </li> */}

          {/* <li>
            <Link to="/resources">Resources</Link>
          </li> */}
          <li>
            <Link to="#">Resources</Link>
          </li>
          <li>
            <Link to="/contact-us">Contact us</Link>
          </li>
          <li>
            <Link to="/about-us">About us</Link>
          </li>
        </ul>

        {/* Right Side */}
        <div className={`navbar-actions ${menuOpen ? "open" : ""}`}>
          <Link
            to="/login"
            className="login-btn flex items-center gap-2 text-gray-700 hover:text-orange-500 transition"
          >
            <FaSignInAlt className="nav-icon text-lg" />
            Login
          </Link>

          <span className="divider w-px h-5 bg-gray-300"></span>

          <Link
            to="/contact-us"
            className="demo-btn equst-demo flex items-center gap-2 text-orange-500 hover:text-orange-600 font-medium transition"
          >
            <FaPaperPlane className="nav-icon text-lg" />
            Request a demo
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
